// A refund method or an action offered when every expression in whens matches, kept exactly as stored.
export interface OutcomeRule {
  target: string
  timing: string
  whens: string[]
}

export interface RefundConfiguration {
  methods: OutcomeRule[]
  actions: OutcomeRule[]
  roundPromocode: boolean
  revokeConditionalDiscounts: boolean
}

export const REFUND_CONFIGURATION_METHODS = [
  'ORIGINAL',
  'GIFT_CARD',
  'PROMO_CODE',
  'BANK_TRANSFER',
  'MANUAL'
]

export const REFUND_CONFIGURATION_ACTIONS = ['TO_RETURN', 'TO_EXCHANGE']

export const REFUND_TIMINGS = [
  'ON_START_RETURN_PROCESS',
  'ON_ITEM_SENT',
  'ON_ITEM_VERIFIED'
]

export const DEFAULT_REFUND_CONFIGURATION: RefundConfiguration = {
  methods: [],
  actions: [],
  roundPromocode: false,
  revokeConditionalDiscounts: false
}

export const REVER_ONLY_REFUND_FIELDS = [
  'roundPromocode',
  'revokeConditionalDiscounts'
] satisfies (keyof RefundConfiguration)[]
